var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{staticClass:"line",attrs:{"fill":"currentColor","d":"m18.552 15.424 6.808-7.768h-1.616l-5.912 6.744-4.72-6.744h-5.448l7.136 10.2-7.136 8.152h1.616l6.24-7.128 4.984 7.128h5.448l-7.408-10.584h0Zm-2.208 2.52-.72-1.016L9.864 8.84h2.48l4.648 6.528.72 1.016 6.04 8.48h-2.48l-4.928-6.92h0Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }